import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export const Circle = styled.div`
  position: absolute;

  width: 79vw;
  height: 103vw;
  transform: translate(-58%, -66%);
  background-image: ${({ theme }) => theme.colors.yellowGrad};
  border-radius: 50%;
  max-width: 1300px;
  max-height: 1100px;

  ${({ theme }) => theme.media.tablet} {
    width: 92vw;
    height: 59vw;
  }

  ${({ theme }) => theme.media.mobile} {
    display: none;
  }
`;
